/**
 * TimeTravelDatePicker — thin wrapper around the reusable DateRangePresetPicker
 * from @strivelabs/ui-blocks, re-exporting the value types needed by
 * GoogleAdsReportViewer and the time-travel hook.
 */
import { DateRangePresetPicker } from '@strivelabs/ui-blocks';
import type {
  DateRangePresetPickerValue,
  DateRangePresetDateRange,
} from '@strivelabs/ui-blocks';

// Re-export types under their original names so existing consumers don't break.
export type DateRange = DateRangePresetDateRange;
export type TimeTravelDateState = DateRangePresetPickerValue;

interface TimeTravelDatePickerProps {
  value: TimeTravelDateState | null;
  onChange: (state: TimeTravelDateState | null) => void;
  isLoading?: boolean;
}

export function TimeTravelDatePicker({
  value,
  onChange,
  isLoading,
}: TimeTravelDatePickerProps) {
  return (
    <DateRangePresetPicker
      value={value}
      onChange={onChange}
      isLoading={isLoading}
    />
  );
}
